'use client';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { ResponsiveImageWithSkeletonWrapper } from '../Image';
import { Skeleton } from '../Skeleton';
import * as Styles from './styles';
export const MediaThumbnail = ({ onClick, isVideo = false, videoOverlayContent = _jsx(Styles.VideoPlayIcon, { children: "\u25BA" }), ...rest }) => {
    const [resolvedSrc, setResolvedSrc] = useState(null);
    useEffect(() => {
        let onCanPlay;
        let videoRef;
        if (isVideo) {
            const canvas = document.createElement('canvas');
            let baseWidth = canvas.width;
            let baseHeight = canvas.height;
            if (rest.widths.md && Number(rest.height)) {
                baseWidth = rest.widths.md;
                baseHeight = Number(rest.height);
            }
            canvas.width = baseWidth * 2;
            canvas.height = baseHeight * 2;
            const ctx = canvas.getContext('2d');
            videoRef = document.createElement('video');
            videoRef.crossOrigin = 'anonymous';
            videoRef.src = rest.src;
            onCanPlay = () => {
                ctx.drawImage(videoRef, 0, 0, canvas.width, canvas.height);
                setResolvedSrc(canvas.toDataURL('image/jpeg'));
                videoRef.removeEventListener('canplay', onCanPlay);
            };
            videoRef.addEventListener('canplay', onCanPlay);
        }
        else {
            setResolvedSrc(rest.src);
        }
        return () => {
            if (videoRef) {
                videoRef.removeEventListener('canplay', onCanPlay);
            }
        };
    }, [isVideo, rest.height, rest.src, rest.widths.md]);
    return (_jsx(Styles.Wrapper, { children: resolvedSrc ? (_jsxs(_Fragment, { children: [_jsx(ResponsiveImageWithSkeletonWrapper, { ...rest, onClick: onClick, src: resolvedSrc, style: { borderRadius: '5px', cursor: 'pointer' }, loading: isVideo ? 'lazy' : 'default', draggable: false }), isVideo ? (_jsx(Styles.VideoOverlay, { onClick: onClick, children: videoOverlayContent })) : null] })) : (_jsx(Skeleton, { style: { borderRadius: '5px' }, animated: true, width: '100%', aspectRatio: rest.aspectRatios?.md ?? rest.aspectRatios?.sm ?? undefined })) }));
};
//# sourceMappingURL=index.js.map